import { render } from "./DetalleEnemigo.vue?vue&type=template&id=3778087b"
import script from "./DetalleEnemigo.vue?vue&type=script&lang=js"
export * from "./DetalleEnemigo.vue?vue&type=script&lang=js"

import "./DetalleEnemigo.vue?vue&type=style&index=0&id=3778087b&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__